import React, { useEffect, useRef, useState } from "react";
import { ICountData } from "../../exports/interfaces";
import { CountUp } from "use-count-up";
import { useEventContext } from "../../context/EventContext";

const BenefitsOfMember = (props: {
  countData: ICountData[];
  memberCount: number;
  countryCount: number;
}) => {
  const { eventData } = useEventContext();
  const [startCount, setStartCount] = useState(false);
  const counterRef = useRef<HTMLUListElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.1 },
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="we-change">
      <div className="we-change-bg-box">
        <div
          className="we-change-bg jarallax"
          data-jarallax
          data-speed="0.2"
          data-imgPosition="50% 0%"
          style={{
            backgroundImage:
              props?.countData[0]?.image[0]?.media?.url &&
              `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.countData[0]?.image[0]?.media?.name})`,
            backgroundSize: "cover",
            backgroundPosition: "center 30%",
          }}
        ></div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-8">
            <div className="we-change__left">
              <p className="we-change__sub-title">
                {props?.countData[0]?.primary_title}
              </p>
              <h3 className="we-change__title">
                {props?.countData[0]?.secondary_title}
              </h3>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
            <div className="we-change__right">
              <ul ref={counterRef} className="we-change__counter list-unstyled">
                {/* <li
                  className="we-change__counter-single wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="we-change__counter-icon custom-we-change__counter-icon">
                    <span className="icon-stethoscope"></span>
                  </div>
                  <div className="we-change__counter-content custom-we-change__counter-content">
                    <h3 className="odometer">
                      <CountUp isCounting={startCount} end={props?.memberCount} duration={3} />
                    </h3>
                    <p className="we-change__counter-text custom-we-change__counter-text">
                      Total {props?.memberCount > 1 ? 'Members' : 'Member'}
                    </p>
                  </div>
                </li> */}
                <li
                  className="we-change__counter-single wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="we-change__counter-icon we-change__counter-icon-clr-extra custom-we-change__counter-icon">
                    <span className="icon-peace-1"></span>
                  </div>
                  <div className="we-change__counter-content custom-we-change__counter-content">
                    <h3 className="odometer">
                      <CountUp
                        isCounting={startCount}
                        end={props?.countryCount}
                        duration={3}
                      />
                    </h3>
                    <p className="we-change__counter-text custom-we-change__counter-text">
                      Total Member{" "}
                      {props?.countryCount > 1 ? "Countries" : "Country"}
                    </p>
                  </div>
                </li>
                <li
                  className="we-change__counter-single wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="we-change__counter-icon we-change__counter-icon-clr-secondary custom-we-change__counter-icon">
                    <span className="icon-campaign"></span>
                  </div>
                  <div className="we-change__counter-content custom-we-change__counter-content">
                    <h3 className="odometer">
                      <CountUp
                        isCounting={startCount}
                        end={eventData?.length}
                        duration={3}
                      />
                    </h3>
                    <p className="we-change__counter-text custom-we-change__counter-text">
                      Total {eventData?.length > 1 ? "Events" : "Event"}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsOfMember;
